var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6748 16.2622C20.0824 16.6348 20.1108 17.2673 19.7382 17.6749L18.7381 18.769C18.0285 19.545 17.0459 20.0002 16.0002 20.0002C14.9549 20.0002 13.9727 19.5454 13.2631 18.7698C12.9112 18.3865 12.4549 18.1903 12.0003 18.1903C11.5454 18.1903 11.0889 18.3867 10.7369 18.7703C10.3635 19.1773 9.73097 19.2045 9.32402 18.8311C8.91707 18.4578 8.88985 17.8252 9.26323 17.4182C9.97356 16.644 10.9555 16.1903 12.0003 16.1903C13.045 16.1903 14.027 16.644 14.7373 17.4182L14.7385 17.4195C15.0897 17.8036 15.5458 18.0002 16.0002 18.0002C16.4546 18.0002 16.9107 17.8036 17.2619 17.4196L18.262 16.3255C18.6346 15.9179 19.2672 15.8895 19.6748 16.2622Z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.793 1.79312C15.012 0.57417 16.9883 0.574167 18.2072 1.79312C19.4262 3.01207 19.4262 4.98838 18.2072 6.20733L5.64449 18.7701C5.6247 18.7899 5.60508 18.8095 5.58562 18.829C5.29817 19.117 5.04474 19.3709 4.7392 19.5581C4.47078 19.7226 4.17815 19.8438 3.87204 19.9173C3.52359 20.001 3.16484 20.0007 2.75794 20.0003C2.7304 20.0003 2.70264 20.0002 2.67464 20.0002H1.0001C0.447817 20.0002 0.00010175 19.5525 0.00010175 19.0002V17.3257C0.00010175 17.2977 7.5882e-05 17.2699 5.0252e-05 17.2424C-0.000328357 16.8355 -0.000662141 16.4768 0.0829922 16.1283C0.156483 15.8222 0.277696 15.5296 0.442182 15.2612C0.629418 14.9556 0.883329 14.7022 1.17132 14.4147C1.19081 14.3953 1.21046 14.3757 1.23026 14.3559L13.793 1.79312Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.b5f5d0062d19c57cb9d1e945320b19da.svg";
export { ForwardRef as ReactComponent };